import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  orgAdmin: null,
  superAdmin: null,
};

const roleswitch = createSlice({
  name: "roleswitch",
  initialState,
  reducers: {
    updateOrgAdmin: (state, action) => {
      state.orgAdmin = action.payload.orgAdmin;
    },
    updateSuperAdmin: (state, action) => {
      state.orgAdmin = action.payload.superAdmin;
    },
    resetRoleswitch: () => initialState,
  },
});

export const { updateOrgAdmin, updateSuperAdmin, resetRoleswitch } =
  roleswitch.actions;

const { reducer } = roleswitch;

export default reducer;
